import { render } from "./gallery.vue?vue&type=template&id=79f36a7e&scoped=true"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"

import "./gallery.vue?vue&type=style&index=0&id=79f36a7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f36a7e"]])

export default __exports__